export default "__VITE_ASSET__DxAfkNfY__"